import React from 'react';
import { FieldValues } from 'react-hook-form';
import * as yup from 'yup';
import { Button, Form } from '@appsumo/dorado-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { yupResolver } from '@hookform/resolvers/yup';

import { useEmailSubscribe } from '~/lib/util/hooks';

interface ComponentNameProps {
  componentName?: string;
  submitText?: string;
  className?: string;
  buttonClassName?: string;
}

const emailFormSchema = yup
  .object({
    email: yup.string().email().required(),
  })
  .required();

export const EmailCapture = ({
  componentName,
  submitText = 'Get 10% Off',
  className,
  buttonClassName = 'w-full md:w-fit',
}: ComponentNameProps): React.ReactElement => {
  const {
    hasEmailError,
    isEmailSubmitted,
    isEmailValid,
    onFormChangeEmail,
    submitEmail,
  } = useEmailSubscribe(componentName);

  function onSubmit(e: React.MouseEvent<HTMLButtonElement>) {
    submitEmail(e);
  }

  const watch = (data: FieldValues) => {
    onFormChangeEmail(data);
  };

  const emailErrorMessage =
    hasEmailError || 'A valid email address is required to get 10% off.';
  const errorMessage = !isEmailValid || hasEmailError ? emailErrorMessage : '';

  if (isEmailSubmitted) {
    return (
      <div className="mt-4 flex items-center rounded bg-dollar-40 px-4 py-3 text-midnight">
        <FontAwesomeIcon
          icon={faCircleCheck}
          height="18"
          className="mr-2 text-lg"
        />
        <span className="text-sm">
          Success! Check your inbox for the coupon code and start saving now!
        </span>
      </div>
    );
  }

  return (
    <Form
      onSubmit={onSubmit}
      resolver={yupResolver(emailFormSchema)}
      watch={watch}
    >
      <div className={className}>
        <div className="w-full max-w-2xl">
          <Form.Input
            name="email"
            error={errorMessage}
            label="Email"
            labelClasses="text-white font-semibold font-header"
          />
        </div>
        <div>
          <Button
            type="submit"
            disabled={!!errorMessage}
            className={buttonClassName}
          >
            {submitText}
          </Button>
        </div>
      </div>
    </Form>
  );
};
